import { defineMessages } from 'react-intl';

import { ContentSections } from '../../../constants/ContentSections';

export const messages = defineMessages({
  followOnTwitter: {
    id: 't.followOnTwitter',
    defaultMessage: 'Follow On Twitter',
  },
});

export const Actions = Object.freeze({
  ENTER_BACKSTAGE: 'ENTER_BACKSTAGE',
  LEAVE_BACKSTAGE: 'LEAVE_BACKSTAGE',
});

export const Keys = Object.freeze({
  CURRENT_ROUTE: 'currentRoute',
});

export const BackstageLoggerDefaultArgs = Object.freeze({
  header: {
    contentSection: ContentSections.HEADER,
  },
  controlBar: {
    contentSection: ContentSections.CONTROL_BAR,
  },
  similarSongs: {
    contentSection: ContentSections.SIMILAR_SONGS,
  },
  songFeatures: {
    contentSection: ContentSections.SONG_FEATURES,
  },
  lyrics: {
    contentSection: ContentSections.LYRICS,
  },
  credits: {
    contentSection: ContentSections.CREDITS,
  },
  trackList: {
    contentSection: ContentSections.TRACK_LIST,
  },
  copyright: {
    contentSection: ContentSections.COPYRIGHT,
  },
  songsOnStation: {
    contentSection: ContentSections.SONGS_ON_STATION,
  },
  artistsOnStation: {
    contentSection: ContentSections.ARTISTS_ON_STATION,
  },
  topSongs: {
    contentSection: ContentSections.TOP_SONGS,
  },
  artistRadio: {
    contentSection: ContentSections.ARTIST_RADIO,
  },
  latestRelease: {
    contentSection: ContentSections.LATEST_RELEASE,
  },
  topAlbums: {
    contentSection: ContentSections.TOP_ALBUMS,
  },
  similarArtists: {
    contentSection: ContentSections.SIMILAR_ARTISTS,
  },
  description: {
    contentSection: ContentSections.DESCRIPTION,
  },
});
